'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = entities;

var _redux = require('redux');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _reduxBatchedActions = require('redux-batched-actions');

var _entity = require('./entity');

var _entity2 = _interopRequireDefault(_entity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createReducer(schemas) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var entitiesReducers = Object.keys(schemas).reduce(function (memo, k) {
    return _extends({}, memo, _defineProperty({}, k, (0, _entity2.default)(schemas[k], initialState[k])));
  }, {});
  return (0, _redux.combineReducers)(entitiesReducers);
}

function entities(schemas, initialState) {
  if ((0, _isEmpty2.default)(schemas)) {
    throw new Error('[INVALID SCHEMAS]');
  }
  return (0, _reduxBatchedActions.enableBatching)(createReducer(schemas, initialState));
}